import { Theme } from '@mui/material';

const html = (theme: Theme) => `
<html>
  <head>
    <title>Preview</title>
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <link rel="preconnect" href="https://fonts.googleapis.com"><link rel="preconnect" href="https://fonts.gstatic.com" crossorigin><link href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap" rel="stylesheet">
    <style>
      * {
        font-family: 'Roboto', sans-serif;
        margin: 0;
        padding: 0;
      }
      body {
        background-color: white;
      }
      .wrapper {
        display: flex;
        flex-direction: column;
        min-height: 100vh;
        background-color: ${theme.palette.primary.main};
      }
      .header {
        display: flex;
        flex-direction: row;
        padding: 15px;
      }
      .header h1 {
        font-size: 18px;
        color: white;
        margin-left: 10px;
      }
      .content {
        background-color: white;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        flex-grow: 1;
        overflow: auto;
        padding: 20px;
      }
      .content .title {
        font-size: 23px;
        margin-bottom: 15px;
        color: ${theme.palette.grey[700]}
      }
      .content .youtube-thumb, .content .main-image {
        width: 100%;
      }
      .content .html {
        color: ${theme.palette.grey[700]};
        font-size: 14px;
        font-weight: normal;
        margin-top: 15px;
        list-style-position: inside;
        white-space: pre-wrap;
      }
    </style>
  </head>
  <body>
    <div class="wrapper">
      <div class="header">
        <svg width="18" height="18" fill="#ffffff" viewBox="0 -6.5 38 38">
          <g transform="translate(-1641.000000, -158.000000)" fill="#ffffff" fill-rule="nonzero">
              <g id="1" transform="translate(1350.000000, 120.000000)">
                  <path d="M317.812138,38.5802109 L328.325224,49.0042713 L328.41312,49.0858421 C328.764883,49.4346574 328.96954,49.8946897 329,50.4382227 L328.998248,50.6209428 C328.97273,51.0514917 328.80819,51.4628128 328.48394,51.8313977 L328.36126,51.9580208 L317.812138,62.4197891 C317.031988,63.1934036 315.770571,63.1934036 314.990421,62.4197891 C314.205605,61.6415481 314.205605,60.3762573 314.990358,59.5980789 L322.274264,52.3739093 L292.99947,52.3746291 C291.897068,52.3746291 291,51.4850764 291,50.3835318 C291,49.2819872 291.897068,48.3924345 292.999445,48.3924345 L322.039203,48.3917152 L314.990421,41.4019837 C314.205605,40.6237427 314.205605,39.3584519 314.990421,38.5802109 C315.770571,37.8065964 317.031988,37.8065964 317.812138,38.5802109 Z" id="left-arrow" transform="translate(310.000000, 50.500000) scale(-1, 1) translate(-310.000000, -50.500000) " />
              </g>
          </g>
        </svg>
        <h1>Matéria</h1>
      </div>
      <div class="content">
        $content
      </div>
    </div>
  </body>
</html>
`;

export default html;
